import { ITheme } from "survey-core";
import { alpha } from "@mui/system";
import { FaRegEye } from "react-icons/fa";
import { styled } from "@mui/material";
import colors from "../../../styles/colors/colors";
import others from "../../../styles/colors/others";
import fontWeight from "../../../styles/mui/fontWeight";


export const renderRowStyle = () => ({
  display: "flex", 
  paddingLeft: "1rem",
});

export const BottomGrid = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  paddingTop: "0.5rem",
  borderRadius: "1.2rem",
});

export const BottomGridMiddleContainer = () => ({
  padding: "0.5rem 0 0.5rem 1.5rem",
});

export const MainLabelContainer = () => ({
  padding: "1rem 0 0 1.5rem",
});

export const BottomGridMiddleContainerField = () => ({
  padding: "1rem 0rem",
  wordBreak: "break-all"
});

export const ReadOnlyFieldStyle = () => ({
  padding: "0.5rem 0rem",
  wordBreak: "break-all",
  display :'flex',
  alignItems: 'center',
});

export const RightTopGrid = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  paddingTop: "0.5rem",
  borderRadius: "1.2rem",
  marginBottom: "0.8rem",
});

export const StateField = () => ({
  padding: "1rem 0 1rem 1.5rem",
  wordBreak: "break-all"
});

export const OuterBodyGrid = () => ({
  backgroundColor: colors.backgroundColor[7],
  opacity: 1,
  padding: "1rem 1rem",
  marginTop: "1.8rem",
  borderRadius: "1.2rem",
});

export const TopGrid = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "0.5rem 1rem 0 1rem",
  marginBottom: "0.8rem",
  borderRadius: "0.8rem",
  width: "100%",
});

export const LabelHeader = () => ({
  display: "flex",
  marginLeft: "1rem",
});

export const TableWidth = () => ({
  minWidth: "92%",
});

export const BodyTable = () => ({
  "& .MuiTableCell-root": {
    borderBottom: `0.05rem solid ${alpha(colors.black[7], 0.35)}`,
    borderRight: "none",
    borderLeft: "none",
  },
  "& th:first-of-type": {
    borderRadius: "0.5rem 0 0 0.5rem",
    borderBottom: "0",
  },
  "& th:last-child": {
    borderRadius: "0 0.5rem 0.5rem 0",
    borderBottom: "0",
  },
});

export const HeaderItem = () => ({
  backgroundColor: colors.backgroundColor[8],
  color: colors.black[2],
  fontWeight: fontWeight.Weight[4],
  borderRadius: "0.5rem",
  height: "1rem",
  position: "sticky",
  top: 0,
});

export const IconFaRegEye = styled(FaRegEye)(() => ({
  color: colors.black[1],
  cursor: "pointer",
  marginRight: "1.5rem",
}));

export const IconContainer = () => ({
  position: "relative",
  display: "inline-block",
  "&:hover .tooltip": {
    opacity: 1,
    zIndex: 2,
  },
});

export const IconName = () => ({
  position: "absolute",
  top: "-1rem",
  left: "25%",
  transform: "translateX(-50%)",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  color: "white",
  padding: "0rem 0.4rem",
  borderRadius: "0.2rem",
  fontSize: "0.7rem",
  opacity: "0",
  transition: "opacity 0.3s ease",
});

export const NotesMainGrid = () => ({
  background: others.otherColors[33],
  boxShadow: `0.0487rem 0.15rem 0.78rem ${colors.dropShadow[4]}`,
  opacity: 1,
  padding: "1rem 1rem",
  marginBottom: "0.8rem",
  borderRadius: "0.8rem",
  width: "100%",
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "flex-start",
  overflow: "hidden",
});

export const NoteViewGrid = () => ({
  pl: "1rem", 
  height: "100%", 
  minWidth: "46rem",
});

export const NotesViewPanel = () => ({
  height: "100%",
  minHeight: "30vh",
  maxHeight: "auto",
  backgroundColor: "#f5f5f5",
  borderRadius: "8px",
  padding: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const ClickableEvents = {
  "& .sd-footer": {
    pointerEvents: "auto",
  },
};

export const NotePreviewStyle = () => ({
  pointerEvents: "none",
  width: "100%",
  height: "100%",
});

export const SurveyStyling: ITheme = {
  backgroundImage: "",
  backgroundImageFit: "contain",
  backgroundImageAttachment: "scroll",
  backgroundOpacity: 1,
  isPanelless: true,
  cssVariables: {
    "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
    "--sjs-general-backcolor-dark": "rgba(248, 248, 248, 1)",
    "--sjs-general-backcolor-dim": others.otherColors[33],
    "--sjs-general-backcolor-dim-light": "rgba(249, 249, 249, 1)",
    "--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
    "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-primary-backcolor": colors.primary.main,
    "--sjs-primary-backcolor-light": "rgba(26, 59, 122, 0.1)",
    "--sjs-primary-backcolor-dark": "rgba(29, 66, 137, 1)",
    "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-base-unit": "5.6px",
    "--sjs-corner-radius": "20px",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small": "0px 1px 2px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
    "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner":
      "0px 2px 0px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 0px #000000",
    "--sjs-shadow-inner-reset":
      "0px 0px 0px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 0px #000000",
    "--sjs-border-light": "rgba(0, 0, 0, 0.09)",
    "--sjs-border-default": "rgba(17, 19, 19, 0.16)",
    "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
    "--sjs-special-red": "rgba(229, 10, 62, 1)",
    "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
    "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-green": "rgba(25, 179, 148, 1)",
    "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
    "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-blue": "rgba(67, 127, 217, 1)",
    "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
    "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
    "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs-question-background": "rgba(255, 255, 255, 0)",
    "--sjs-font-size": "13px",
    "--sjs-questionpanel-cornerRadius": "26px",
    "--sjs-font-questiondescription-weight": "700",
    "--sjs-font-questiondescription-size": "22px",
    "--sjs-font-questiontitle-weight": "700",
    "--sjs-editorpanel-cornerRadius": "2px",
    "--sjs-editor-background": "rgba(255, 255, 255, 1)",
  },
  themeName: "default_exported",
  colorPalette: "light",
};